import styled from '@emotion/styled';
import RightArrow from '../../../../../components/Icon/right-arrow.svg';

export default styled(RightArrow)({
    alignSelf: 'center',
    gridArea: 'icon',
    height: '16px',
    width: '10px'
});
